var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_950_3387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.61212 15.4436C3.22612 15.6416 2.78812 15.2946 2.86612 14.8516L3.69612 10.1216L0.173118 6.76562C-0.155882 6.45162 0.0151183 5.87762 0.456118 5.81562L5.35412 5.11962L7.53812 0.792622C7.73512 0.402622 8.26812 0.402622 8.46512 0.792622L10.6491 5.11962L15.5471 5.81562C15.9881 5.87762 16.1591 6.45162 15.8291 6.76562L12.3071 10.1216L13.1371 14.8516C13.2151 15.2946 12.7771 15.6416 12.3911 15.4436L8.00012 13.1876L3.61112 15.4436H3.61212Z",
    fill: "#FDC932"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_950_3387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellowIcon);
export default __webpack_public_path__ + "static/media/star-yellow-icon.a3dbf88d042146f86f42a3b2099aa284.svg";
export { ForwardRef as ReactComponent };